// Self-audit guard — mirrors the Figma plugin's "snapsiteux.com easter egg".
//
// We don't audit our own product site. If someone points the web tool at
// snapsiteux.com (or any subdomain) we short-circuit before any API call or
// credit charge and show a hardcoded message, exactly like the plugin does.

const SNAP_SITE_DOMAIN = "snapsiteux.com";

// Hardcoded copy, voiced like the plugin's overlay ("Cheeky one. 👀") but
// without the "we dropped something on the canvas" line — the web tool has no
// canvas to plant a frame on.
export const SELF_AUDIT_MESSAGE =
  "Cheeky one 👀 — Snap Site can't audit Snap Site. Point it at a site you're actually working on (your credits are safe).";

/**
 * True when the entered URL is our own product site. Tolerant of the
 * scheme-less input people type into the audit box (e.g. "snapsiteux.com"),
 * so we normalize a missing scheme before parsing. Matches the host exactly
 * or any subdomain (www.snapsiteux.com, app.snapsiteux.com, …), and never a
 * lookalike (notsnapsiteux.com, snapsiteux.com.evil.com).
 */
export function isOurOwnDomain(rawUrl: string): boolean {
  const trimmed = rawUrl.trim();
  if (!trimmed) return false;
  const candidate = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const host = new URL(candidate).hostname.toLowerCase();
    return host === SNAP_SITE_DOMAIN || host.endsWith(`.${SNAP_SITE_DOMAIN}`);
  } catch {
    return false;
  }
}
